// extracted by mini-css-extract-plugin
export default {"asset":"VisualMedia_asset__+i-r5"};